var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightBottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 157,
    viewBox: "0 0 183 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M313 156.5C313 242.933 242.933 313 156.5 313C70.0674 313 0 242.933 0 156.5C0 70.0674 70.0674 0 156.5 0C242.933 0 313 70.0674 313 156.5ZM59.5654 156.5C59.5654 210.035 102.965 253.435 156.5 253.435C210.035 253.435 253.435 210.035 253.435 156.5C253.435 102.965 210.035 59.5654 156.5 59.5654C102.965 59.5654 59.5654 102.965 59.5654 156.5Z",
    fill: "#0B2E75",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBottom);
export default __webpack_public_path__ + "static/media/right-bottom.4d2e74018dbb66e20f14a40c65b1818d.svg";
export { ForwardRef as ReactComponent };